import React from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { internationalclients } from "./getconstdata";

const Internationalclients = ({ getData, getOnSave }) => {
  const onSelect = (value) => {
    getOnSave("internationalclients", value);
  };

  return (
    <>
      <section className="internationalClientsSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>
                  5. Are you experienced working directly with international
                  clients?
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormControl component="fieldset" className="expRadio">
                <RadioGroup
                  aria-label="internationalclients"
                  defaultValue="yes"
                  name="radio-buttons-group"
                  onChange={(e) => onSelect(e.target.value)}
                  value={getData}
                >
                  {internationalclients.map((s) => (
                    <FormControlLabel
                      value={s.value}
                      className="radioLabel"
                      control={<Radio />}
                      label={s.label}
                      key={s.value}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Internationalclients;
